import { Group, InputWrapper, NumberInput } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { TimeFramesInSeconds } from 'models/rules';
import { secondsToTimeWindow } from 'utils/helpers';
import { displayFormError } from 'utils/validation';

export const TimeSincePrescriptionFields = () => {
  const { t } = useTranslation();
  const { setFieldValue, values, getInputProps, errors } = useCreateRuleFormContext();

  const dataField = 'data.timeSincePrescription.timeWindow';

  const timeInSeconds = getInputProps(`${dataField}`).value;
  const fields = secondsToTimeWindow(timeInSeconds);

  const [timeInput, setTimeInput] = useState<string | number>(fields.value || '');

  const handleChangeTime = (value: string | number) => {
    setTimeInput(value);
    const seconds = TimeFramesInSeconds.days * Number(value);
    setFieldValue(dataField, seconds > 0 ? seconds : undefined);
  };

  return (
    <>
      <Group gap={'md'}>
        <InputWrapper label={t('trigger_after_label')}>
          <Group gap={'xs'}>
            <NumberInput
              onChange={handleChangeTime}
              value={timeInput}
              hideControls
              placeholder={errors[dataField] ? '' : '1'}
              allowNegative={false}
              allowDecimal={false}
              min={1}
              max={1000}
              disabled={values.formDisabled}
              clampBehavior={'strict'}
              error={displayFormError({ errors, dataField })}
            />
            {t('days_label')}
          </Group>
        </InputWrapper>
      </Group>
    </>
  );
};
